import React from 'react';
import PropTypes from 'prop-types';
import { createCustomEvent, handleEnterSpaceKey, isNullOrUndefOrEmpty } from 'utils';
import classNames from 'classnames';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/RadioQuestionOption.scss';

const RadioQuestionOption = ({
  radioName, className, option, onRadioSelected, isEmoji, isImage, isDisabled, autoAdvance = false
}) => {
  const { id, text, selected, img } = option;
  const radioId = `${radioName}-${id}`;
  const hasImage = !isNullOrUndefOrEmpty(img);

  const handleOnClick = () => {
    if (isDisabled) {
      return;
    }
    return onRadioSelected(option, autoAdvance);
  };

  const handleRadioChange = () => {
    if (isDisabled) {
      return;
    }
    return onRadioSelected(option);
  };

  const handleOnKeyUp = (event) => {
    if (isDisabled) {
      return;
    }
    return handleEnterSpaceKey(event, () => onRadioSelected(option));
  };

  const onImageLoad = () => {
    const resizeEvent = createCustomEvent('resize', true);
    window.dispatchEvent(resizeEvent);
  };

  return (
    <li className={classNames('csw-q-rdo-o csw-q-option', className,
      { 'csw-q-rdo-img-o': isImage, 'csw-q-rdo-emoji-o': isEmoji })}
        aria-labelledby={`${radioId}-lbl`}>
      <input className="csw-q-rdo-input csw-q-option-input sr-only outline-trigger"
             type="radio"
             name={radioName}
             id={radioId}
             value={text}
             disabled={isDisabled}
             defaultChecked={selected}
             aria-checked={selected}
             onChange={handleRadioChange}
             onKeyUp={handleOnKeyUp}/>
      <label className="csw-q-rdo-lbl csw-q-option-lbl outline"
             id={`${radioId}-lbl`}
             htmlFor={radioId}
             onClick={handleOnClick}
             onKeyUp={handleOnKeyUp}
             role="radio"
             aria-disabled={isDisabled}
             aria-checked={selected}>

        {(isImage && hasImage) && <figure>
          <img className="csw-q-rdo-img-file" alt={text} src={img}
               onLoad={onImageLoad}/>
          <figcaption className="csw-q-rdo-img-txt">{text}</figcaption>
        </figure>}

        {isEmoji && <i className="csw-q-rdo-emoji-txt" role="img">{text}</i>}

        {!(isEmoji || isImage) && <>
          <span className="csw-q-rdo-chk csw-option-check-border"
                aria-hidden="true">{' '}</span>
          <span className="csw-q-rdo-txt">
            {text}
          </span>
        </>}
      </label>
    </li>
  );
};

RadioQuestionOption.propTypes /* remove-proptypes */ = {
  radioName: PropTypes.string,
  className: PropTypes.string,
  option: PropTypes.object.isRequired,
  onRadioSelected: PropTypes.func.isRequired,
  isEmoji: PropTypes.bool,
  isImage: PropTypes.bool,
  isDisabled: PropTypes.bool,
  autoAdvance: PropTypes.bool
};

export default RadioQuestionOption;
